import { IDateRange } from "../../types/filter"

export enum UserActionTypes {
  FETCH_DEFAULT_ORDER_SUCCESS = "FETCH_DEFAULT_ORDER_SUCCESS",
  FETCH_DEFAULT_ORDER_ERROR = "FETCH_DEFAULT_ORDER_ERROR",
  FETCH_DEFAULT_ORDER = "FETCH_DEFAULT_ORDER",
  SET_DEFAULT_ORDER = "SET_DEFAULT_ORDER",
  SET_IS_ORDER = "SET_IS_ORDER",
  SET_DATE_RANGE = "SET_DATE_RANGE",
  SET_COUNTRY_CODE = "SET_COUNTRY_CODE",
}

interface FetchDefaultOrder {
  type: UserActionTypes.FETCH_DEFAULT_ORDER
}

interface FetchDefaultOrderSuccess {
  type: UserActionTypes.FETCH_DEFAULT_ORDER_SUCCESS
  payload: number
}

interface FetchDefaultOrderError {
  type: UserActionTypes.FETCH_DEFAULT_ORDER_ERROR
  payload: string
}

interface SetDefaultOrder {
  type: UserActionTypes.SET_DEFAULT_ORDER
  payload: number
}

interface SetIsOrderAction {
  type: UserActionTypes.SET_IS_ORDER
  payload: boolean
}

interface SetDateRange {
  type: UserActionTypes.SET_DATE_RANGE
  payload: {
    from: string
    to: string
  }
}

interface SetCountryCode {
  type: UserActionTypes.SET_COUNTRY_CODE
  payload: string
}

export type FilterAction =
  | SetIsOrderAction
  | SetDateRange
  | SetDefaultOrder
  | FetchDefaultOrder
  | FetchDefaultOrderSuccess
  | FetchDefaultOrderError
  | SetCountryCode

export interface FilterState {
  dateRange: IDateRange
  isOrder: boolean
  defaultOrder: number
  countryCode: string
  loaded: boolean
  error: string | null
}
